module.exports = __webpack_public_path__ + "img/button-bg.b8ca67b6.svg";